import { useEffect, useState } from "react";

const useIsIOS = () => {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent =
      window.navigator.userAgent || window.navigator.vendor || window.opera;

    // Check for iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setIsIOS(true);
    } else {
      setIsIOS(false);
    }
  }, []);

  return isIOS;
};

export default useIsIOS;


